<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>

<script>
import Common from "@/assets/js/common.js";
import interfaces from "@/interfaces/index";
import wxList from "@/assets/js/wxList";
export default {
  name: "App",
  watch: {
    $route(to, from) {
      // 微信登录
      if (Common.getUrlQuery("actionType")) {
        var actionType = Common.getUrlQuery("actionType").toLowerCase();
      }
      // 不是白名单的走微信登录
      if (!wxList.isWhite(to.path)) {
        var code = Common.getUrlQuery("code");
        if (actionType && actionType === "wechatlogin" && code) {
          if (code !== localStorage.getItem("code") && !sessionStorage.getItem('toH5Mall')) {
            localStorage.setItem("code", code);
            this._user.logout();
            this.autoWXLogin(to, from);

          }
        }
      }
      // 支付宝登录
      var actionType2 = "";
      if (Common.getQueryString("actionType")) {
        actionType2 = Common.getQueryString("actionType").toLowerCase();
      }
      if (!actionType2) {
        actionType2 = Common.getUrlQuery("actionType").toLowerCase();
      }
      var alicode = Common.getQueryString("auth_code");
      if (actionType2 && actionType2 === "alilogin" && alicode) {
        if (alicode !== localStorage.getItem("auth_code")) {
          localStorage.setItem("auth_code", alicode);
          this._user.logout();
          this.autoAliLogin(to, from);
        }
      }
    }
  },
  methods: {
    // 微信登录
    async autoWXLogin(to, from) {
      console.log(to,from);
      let params = {
        Code: Common.getUrlQuery("code")
      };
      if (to.path == '/upgradesTrip') {
        // 如果走的是值机柜台升舱和登机口升舱这个入口走这个微信登录
        let res = await interfaces.spWxLogin(params);
        if (res.data.ErrorCode === 0) {
          this._user.setSessionId(res.data.Result.SessionID);
          this._user.setIsCertified(res.data.Result.IsCertified);
          //增加登陆token缓存，以便调用云商城token登陆
          sessionStorage.setItem('token',JSON.stringify(res.data.Result.token));
        }
      } else {
        let res = await interfaces.wxLogin(params);
        if (res.data.ErrorCode === 0) {
          //增加登陆token缓存，以便调用云商城token登陆
          sessionStorage.setItem('token',JSON.stringify(res.data.Result.token));
          if (!res.data.Result.AccountExit) {
            // this._user.logout();
            sessionStorage.setItem("wechatAccountExit", false);
            // 当微信登录的后要跳转的页面不是 dreamEntry 和  register时， 如果没有关联的账号，则跳转到登录页
            if (to.path.indexOf("dreamEntry") == -1 && to.path.indexOf("register") == -1) {
              if (to.path.indexOf("upgradeClass/queryForm") > -1) {
                this.$router.push({ 
                  path: "/login",
                  query:{
                    redirect:'upgradeClass/queryForm'
                  }
                });
              }
              this.$router.push({ path: "/login" }); 
            }
          } else {
            if (process.env.NODE_ENV != 'development') {
                // 自动登录云商城
                let mallres = await interfaces.autoLoginByToken();
                sessionStorage.setItem("wechatAccountExit", true);
                this._user.setSessionId(res.data.Result.SessionID);
                this._user.setIsCertified(res.data.Result.IsCertified);
            }
            
          }
        }
      }
    },
    // 支付宝登录
    async autoAliLogin(to, from) {
      let params = {
        authCode: Common.getQueryString("auth_code")
      };
      let res = await interfaces.aliLogin(params);
      if (res.data.ErrorCode === 0) {
        if (!res.data.Result.accountExit) {
          // this._user.logout();
          sessionStorage.setItem("wechatAccountExit", false);
          if (to.path.indexOf("dreamEntry") == -1 && to.path.indexOf("register") == -1) {
            this.$router.push({ path: "/login" }); 
          }
        } else {
          sessionStorage.setItem("wechatAccountExit", true);
          this._user.setSessionId(res.data.Result.sessionID);
          this._user.setIsCertified(res.data.Result.isCertified);
        }
      }
    }
  }
};
</script>

<style lang="less">
@import "./assets/less/global.less";
#app {
  width: 100%;
  // overflow-x: hidden;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  font-size: 12 * @base;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.padding_top {
  padding-top: 70 * @base;
}
@media screen and (max-width: 320px) {
  #app {
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue